
























































import Vue from 'vue';
import Page from '@/components/Page.vue';
import Card from '@/components/common/Card.vue';
import Errors from '@/components/common/form/Errors.vue';
import CTAButton from '@/components/common/buttons/CTAButton.vue';
import PrimaryButton from '@/components/common/buttons/PrimaryButton.vue';
import SuccessIcon from '../components/common/icons/SuccessIcon.vue';
import SecurePasswordForm from '@/components/common/form/SecurePasswordForm.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions, mapMutations, mapGetters } = createNamespacedHelpers('resetPassword');
const mapCustomLabelsState = createNamespacedHelpers('customLabels').mapState;
export default Vue.extend({
    components: {
        Page,
        Errors,
        CTAButton,
        Card,
        SuccessIcon,
        PrimaryButton,
        SecurePasswordForm,
    },
    data: function() {
        return {
            siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
        };
    },
    computed: {
        ...mapState(['password', 'passwordConfirmation', 'submitted', 'isSending', 'passwordStrength']),
        ...mapCustomLabelsState(['portalTitle', 'accessGrievanceBtn', 'instanceTitle']),
        ...mapGetters(['getFieldErrors']),
    },
    created() {
        const portalTitle = this.portalTitle;
        const instanceTitle = this.instanceTitle;
        document.title = `${instanceTitle} | ${this.$t('htmlTitle', { instanceTitle, portalTitle }) as string}`;
    },
    mounted() {
        this.resetForm();
    },
    methods: {
        ...mapMutations(['setPassword', 'setPasswordConfirmation', 'resetForm', 'setPasswordStrength']),
        ...mapActions(['resetPassword']),
        async submit() {
            await this.resetPassword({ passwordResetToken: this.$route.query.passwordResetToken });
        },
    },
});
